import React, { FC } from 'react'
import { Popover } from 'antd'
import { PopoverProps as AntPopOverProps } from 'antd/lib/popover'

export type PopoverProps = AntPopOverProps

export const PopOver: FC<PopoverProps> = ({
  title,
  content,
  placement,
  trigger,
  children,
  overlayClassName = '',
  onVisibleChange,
  visible,
  ...rest
}) => {
  return (
    <Popover
      title={title}
      content={content}
      placement={placement}
      trigger={trigger}
      {...(visible !== undefined && { visible })}
      {...(onVisibleChange && { onVisibleChange })}
      overlayClassName={overlayClassName}
      {...rest}
    >
      {children}
    </Popover>
  )
}
